<template>
    <div class="payable_component_wrap" v-loading="loading">
        <el-tabs v-model="tabActiveName" @tab-click="handleClickTab">
            <el-tab-pane label="未回款" name="unpaid"> </el-tab-pane>
            <el-tab-pane label="坏账款项" name="badDebt" v-if="hasBadDebtPermission"> </el-tab-pane>
        </el-tabs>
        <div class="content_right_wrap">
            <div class="page-filter_wrap">
                <div class="page-filter_wrap_left">
                    <el-input
                        v-model="searchForm.keyword"
                        class="filter-input"
                        clearable
                        placeholder="请输入您想搜索的内容"
                        @clear="handleClickSearch"
                        @keyup.enter.native="handleClickSearch"
                    >
                        <i slot="suffix" class="iconfont icon-sousuo" @click="handleClickSearch"></i>
                    </el-input>
                    <el-popover placement="bottom-start" width="520" trigger="click">
                        <div class="search_container">
                            <div class="search_top_container">
                                <span class="title">筛选</span>
                                <el-button
                                    @click="handleClickReset"
                                    size="mini"
                                    :disabled="
                                        searchFilterList.findIndex(
                                            (find) => find.field_value && find.field_value.length > 0
                                        ) > -1
                                            ? false
                                            : true
                                    "
                                    >清空筛选条件</el-button
                                >
                            </div>
                            <div class="search_bottom_container">
                                <ul>
                                    <li v-for="item in searchFilterList">
                                        <div>
                                            <el-select size="small" v-model="item.field_key" disabled>
                                                <el-option label="订单负责人" value="salesperson_ids"></el-option>
                                                <el-option label="部门负责人" value="department_head_ids"></el-option>
                                                <el-option label="处理人" value="operator_ids"></el-option>
                                                <el-option label="处理日期" value="operate_date"></el-option>
                                            </el-select>
                                        </div>
                                        <div class="search_filter_type">
                                            <el-select size="small" v-model="item.field_type" disabled>
                                                <el-option label="满足" value="eq"></el-option>
                                                <el-option label="不满足" value="neq"></el-option>
                                            </el-select>
                                        </div>
                                        <div>
                                            <template
                                                v-if="
                                                    item.field_key == 'salesperson_ids' ||
                                                    item.field_key == 'department_head_ids' ||
                                                    item.field_key == 'operator_ids'
                                                "
                                            >
                                                <el-select
                                                    v-model="item.field_value"
                                                    :placeholder="'请选择' + item.field_name"
                                                    :remote-method="getUserList"
                                                    filterable
                                                    remote
                                                    size="small"
                                                    multiple
                                                    :multiple-limit="1"
                                                    @change="handleClickSearch"
                                                >
                                                    <el-option
                                                        v-for="user in userOptions"
                                                        :key="user.uid"
                                                        :label="user.name"
                                                        :value="user.uid"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </template>
                                            <template v-if="item.field_key == 'operate_date'">
                                                <el-date-picker
                                                    v-model="item.field_value"
                                                    end-placeholder="结束时间"
                                                    format="yyyy-MM-dd"
                                                    range-separator="～"
                                                    size="small"
                                                    start-placeholder="开始时间"
                                                    type="daterange"
                                                    value-format="yyyy-MM-dd"
                                                    @clear="item.field_value = []"
                                                    @change="handleClickSearch"
                                                >
                                                </el-date-picker>
                                            </template>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <el-button size="small" slot="reference" class="custom_popover_button">
                            <i class="iconfont icon-shaixuan"></i>
                            <span
                                class="search_filter_length"
                                v-if="
                                    searchFilterList.filter((find) => find.field_value && find.field_value.length > 0)
                                        .length
                                "
                            >
                                <span
                                    v-text="
                                        searchFilterList.filter(
                                            (find) => find.field_value && find.field_value.length > 0
                                        ).length + '个条件'
                                    "
                                ></span>
                                <i class="el-icon-error" @click="handleClickReset"></i>
                            </span>
                        </el-button>
                    </el-popover>
                </div>
                <div class="page-filter_wrap_right" v-if="hasOperatePermission">
                    <el-button type="primary" plain @click="handleClickExport">导出</el-button>
                    <el-button
                        type="primary"
                        plain
                        @click="handleClickBatchDemandPayment"
                        v-if="tabActiveName === 'unpaid'"
                        >批量催款</el-button
                    >
                </div>
            </div>
            <div class="page-content">
                <template>
                    <CustomVxeTable
                        id="payableManageTable"
                        ref="tableRef"
                        :customConfig="tableCustomConfig"
                        :empty-render="{ name: 'NotData' }"
                        :isShowToolBar="true"
                        :pagination.sync="pagination"
                        :reduceHeight="reduceHeight"
                        :tableData="tableData"
                        @handleCurrentChange="handleCurrentChange"
                        @handleSizeChange="handleSizeChange"
                        @selection-change="selectionChange"
                    >
                        <vxe-column fixed="left" type="checkbox" width="42"></vxe-column>
                        <vxe-column fixed="left" field="name" title="客户公司" min-width="164" key="1" show-overflow>
                            <template #default="{ row }">
                                <template v-if="tabActiveName == 'unpaid'">
                                    <span
                                        class="link-label"
                                        @click="
                                            handleClickCustomerDetail(
                                                row.customer_info && row.customer_info.id,
                                                row.customer_info && row.customer_info.name
                                            )
                                        "
                                        >{{ row.customer_info && row.customer_info.name }}</span
                                    >
                                </template>
                                <template v-else>
                                    <span
                                        class="link-label"
                                        @click="handleClickCustomerDetail(row.customer_id, row.customer_name)"
                                        >{{ row.customer_name }}</span
                                    >
                                </template>
                            </template>
                        </vxe-column>
                        <vxe-column field="payable_num" title="订单编号" min-width="158" key="2" show-overflow>
                            <template #default="{ row }">
                                <span class="link-label" @click="handleClickOrderDetail(row)">{{ row.order_num }}</span>
                            </template>
                        </vxe-column>
                        <vxe-column field="user_name" title="订单负责人" width="150" key="3">
                            <template #default="{ row }">
                                <PersonnelCard
                                    :userId="row.salesperson_info.id"
                                    v-if="row.salesperson_info && row.salesperson_info.id"
                                >
                                    <template slot="container">
                                        <div class="user-avatar-btn">
                                            <img
                                                :src="
                                                    row.salesperson_info.avatar
                                                        ? row.salesperson_info.avatar
                                                        : defaultImg
                                                "
                                                alt=""
                                            />
                                            <span>{{ row.salesperson_info.name }}</span>
                                        </div>
                                    </template>
                                </PersonnelCard>
                                <span v-else>--</span>
                            </template>
                        </vxe-column>
                        <vxe-column field="department_name" title="部门负责人" width="150" key="4">
                            <template #default="{ row }">
                                <template v-if="tabActiveName == 'unpaid'">
                                    <template v-if="row.department_leader && row.department_leader.length">
                                        <template v-for="leaderItem in row.department_leader">
                                            <PersonnelCard :userId="leaderItem.uid" v-if="leaderItem && leaderItem.uid">
                                                <template slot="container">
                                                    <div class="user-avatar-btn">
                                                        <img
                                                            :src="leaderItem.avatar ? leaderItem.avatar : defaultImg"
                                                            alt=""
                                                        />
                                                        <span>{{ leaderItem.name }}</span>
                                                    </div>
                                                </template>
                                            </PersonnelCard>
                                        </template>
                                    </template>
                                    <span v-else>--</span>
                                </template>
                                <template v-else>
                                    <template v-if="row.department_leader_info && row.department_leader_info.length">
                                        <template v-for="leaderItem in row.department_leader_info">
                                            <PersonnelCard :userId="leaderItem.uid" v-if="leaderItem && leaderItem.uid">
                                                <template slot="container">
                                                    <div class="user-avatar-btn">
                                                        <img
                                                            :src="leaderItem.avatar ? leaderItem.avatar : defaultImg"
                                                            alt=""
                                                        />
                                                        <span>{{ leaderItem.name }}</span>
                                                    </div>
                                                </template>
                                            </PersonnelCard>
                                        </template>
                                    </template>
                                    <span v-else>--</span>
                                </template>
                            </template>
                        </vxe-column>
                        <vxe-column
                            header-align="right"
                            align="right"
                            field="total_price"
                            title="订单总金额"
                            min-width="126"
                            key="5"
                            show-overflow
                        >
                            <template #default="{ row }">
                                <span
                                    v-text="
                                        Number(row.total_price).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })
                                    "
                                ></span>
                            </template>
                        </vxe-column>
                        <vxe-column
                            header-align="right"
                            align="right"
                            field="repay_price"
                            title="实际回款金额"
                            min-width="146"
                            key="6"
                            show-overflow
                        >
                            <template #default="{ row }">
                                <span
                                    v-text="
                                        Number(row.repay_price).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })
                                    "
                                ></span>
                                <el-popover
                                    placement="bottom-end"
                                    title=""
                                    width="206"
                                    trigger="click"
                                    content=""
                                    popper-class="repayment_log_popover"
                                    v-if="row.repayment_log && row.repayment_log.length"
                                >
                                    <div class="repayment_log_popover_content">
                                        <ul>
                                            <li v-for="(logItem, logIndex) in row.repayment_log" :key="logIndex">
                                                <p>{{ logItem.confirm_time }}</p>
                                                <p>回款：{{ logItem.amount }}元</p>
                                            </li>
                                        </ul>
                                    </div>
                                    <span class="handle_icon_wrap" slot="reference" style="margin-left: 2px">
                                        <i class="iconfont icon-yiwen"></i>
                                    </span>
                                </el-popover>
                            </template>
                        </vxe-column>
                        <vxe-column
                            header-align="right"
                            align="right"
                            field="refund_price"
                            title="退款金额"
                            min-width="136"
                            show-overflow
                            key="11"
                        >
                            <template #default="{ row }">
                                <span
                                    v-text="
                                        Number(row.refund_price).toLocaleString(undefined, {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })
                                    "
                                ></span>
                            </template>
                        </vxe-column>
                        <template v-if="tabActiveName === 'unpaid'">
                            <vxe-column
                                header-align="right"
                                align="right"
                                field="no_repay_price"
                                title="未回款金额"
                                min-width="126"
                                show-overflow
                                key="7"
                            >
                                <template #default="{ row }">
                                    <span
                                        v-text="
                                            Number(row.no_repay_price).toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                        "
                                    ></span>
                                </template>
                            </vxe-column>
                        </template>
                        <template v-else>
                            <vxe-column
                                header-align="right"
                                align="right"
                                field="bad_debt_amount"
                                title="坏账金额"
                                min-width="146"
                                show-overflow
                                key="8"
                            >
                                <template #default="{ row }">
                                    <span
                                        v-text="
                                            Number(row.bad_debt_amount).toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                        "
                                    ></span>
                                    <el-popover
                                        placement="bottom-end"
                                        title=""
                                        width="206"
                                        trigger="click"
                                        content=""
                                        popper-class="repayment_log_popover"
                                        v-if="row.bad_debt_logs && row.bad_debt_logs.length"
                                    >
                                        <div class="repayment_log_popover_content">
                                            <ul>
                                                <li v-for="(logItem, logIndex) in row.bad_debt_logs" :key="logIndex">
                                                    <p>{{ logItem.created_at }}</p>
                                                    <p>{{ logItem.remark }}</p>
                                                </li>
                                            </ul>
                                        </div>
                                        <span class="handle_icon_wrap" slot="reference" style="margin-left: 2px">
                                            <i class="iconfont icon-yiwen"></i>
                                        </span>
                                    </el-popover>
                                </template>
                            </vxe-column>
                        </template>
                        <template v-if="tabActiveName === 'badDebt'">
                            <vxe-column field="mark_operate_time" title="处理日期" width="180" key="9">
                                <template #default="{ row }"
                                    ><span>{{ row.mark_operate_time }}</span></template
                                >
                            </vxe-column>
                            <vxe-column field="handle_name" title="处理人" width="150" key="10">
                                <template #default="{ row }">
                                    <PersonnelCard
                                        :userId="row.mark_operate_info.id"
                                        v-if="row.mark_operate_info && row.mark_operate_info.id"
                                    >
                                        <template slot="container">
                                            <div class="user-avatar-btn">
                                                <img
                                                    :src="
                                                        row.mark_operate_info.avatar
                                                            ? row.mark_operate_info.avatar
                                                            : defaultImg
                                                    "
                                                    alt=""
                                                />
                                                <span>{{ row.mark_operate_info.name }}</span>
                                            </div>
                                        </template>
                                    </PersonnelCard>
                                    <span v-else>--</span>
                                </template>
                            </vxe-column>
                        </template>
                        <vxe-column field="operate" width="90" fixed="right">
                            <template #header>
                                <span>操作</span>
                                <el-tooltip class="item" effect="dark" content="表头设置" placement="bottom-start">
                                    <i
                                        class="iconfont icon-biaotoushezhi table-header-icon"
                                        @click="handleClickCustom"
                                    ></i>
                                </el-tooltip>
                            </template>
                            <template #default="{ row }">
                                <el-dropdown placement="bottom-end" trigger="click">
                                    <el-tooltip effect="dark" content="更多" placement="top"
                                        ><i class="iconfont el-icon-more cursor"></i
                                    ></el-tooltip>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item
                                            @click.native="handleClickBadDebt(row)"
                                            v-if="tabActiveName === 'unpaid' && hasOperatePermission"
                                        >
                                            坏账
                                        </el-dropdown-item>
                                        <el-dropdown-item
                                            @click.native="handleClickDemandPayment(row)"
                                            v-if="tabActiveName === 'unpaid' && hasOperatePermission"
                                        >
                                            催款
                                        </el-dropdown-item>
                                        <el-dropdown-item
                                            @click.native="handleClickCancelBadDebt(row)"
                                            v-if="tabActiveName === 'badDebt' && hasOperatePermission"
                                        >
                                            取消坏账
                                        </el-dropdown-item>
                                        <el-dropdown-item @click.native="handleClickDetail(row)">
                                            详情
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                        </vxe-column>
                        <template #empty>
                            <div class="custom-table-empty">
                                <div class="custom-table-empty-img"></div>
                                <p class="custom-table-empty-txt">暂无数据</p>
                            </div>
                        </template>
                    </CustomVxeTable>
                </template>
            </div>
        </div>
        <BadDebt
            v-if="badDebtDialogVisible"
            :badDebtDialogVisible.sync="badDebtDialogVisible"
            :order_num="order_num"
            @confirmSuccess="getTableData"
        />
        <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :title="handleDialogTitle"
            :visible.sync="handleDialogVisible"
            width="520px"
        >
            <p class="dialog_label_text">催款通知内容</p>
            <el-input
                :placeholder="'请输入催款通知内容'"
                :rows="6"
                maxlength="300"
                type="textarea"
                v-model="handleRemarks"
            >
            </el-input>
            <div align="right" slot="footer">
                <el-button @click="handleClickCancel" size="small">取消</el-button>
                <el-button @click="handleClickConfirm" size="small" type="primary">确定</el-button>
            </div>
        </el-dialog>
        <UnpaidPaymentDetails
            v-if="unpaidDetailsDialogVisible"
            :unpaidDetailsDialogVisible.sync="unpaidDetailsDialogVisible"
            :order_num="order_num"
            @btnOperate="handleDetailBtnOperate"
        />
    </div>
</template>
<script>
import { OrderUnpaidList, GetUserList, OrderCancelBadDebt, OrderUrgePayment, OrderBadDebtList , OrderUnpaidListExport, OrderBadDebtListExport} from "@/api";
import { pagination } from "@/mixins";
import CustomVxeTable from "@/components/pComponents/vxe-table";
import BadDebt from "./component/bad_debt.vue";
import UnpaidPaymentDetails from "./component/unpaid_payment_details.vue";
import PersonnelCard from "@/components/pComponents/PersonnelCard.vue";
import * as XLSX from "xlsx";
import {mapGetters} from "vuex";

export default {
    name: "Repay",
    components: { CustomVxeTable, PersonnelCard, BadDebt, UnpaidPaymentDetails },
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            loading: false,
            tabActiveName: "unpaid",
            searchForm: {
                keyword: "",
            },
            fieldsList: [],
            systemFilterFields: [],
            custom_filter: {},
            tableCustomConfig: {
                allowFixed: false,
                confirmButtonText: "确定",
                resetButtonText: "重置",
                visibleMethod: (col) => {
                    return true;
                },
                checkMethod: (col) => {
                    return col.column.field !== "name";
                },
                allowSort: true,
            },
            tableData: [],
            // 筛选条件
            searchFilterList: [],
            unpaidSearchFilterList: [
                {
                    field_key: "salesperson_ids",
                    field_name: "订单负责人",
                    field_value: [],
                    field_value_name: "",
                    field_type: "eq",
                },
                {
                    field_key: "department_head_ids",
                    field_name: "部门负责人",
                    field_value: [],
                    field_value_name: "",
                    field_type: "eq",
                },
            ],
            badDebtSearchFilterList: [
                {
                    field_key: "salesperson_ids",
                    field_name: "订单负责人",
                    field_value: [],
                    field_value_name: "",
                    field_type: "eq",
                },
                {
                    field_key: "department_head_ids",
                    field_name: "部门负责人",
                    field_value: [],
                    field_value_name: "",
                    field_type: "eq",
                },
                {
                    field_key: "operator_ids",
                    field_name: "处理人",
                    field_value: [],
                    field_value_name: "",
                    field_type: "eq",
                },
                {
                    field_key: "operate_date",
                    field_name: "处理日期",
                    field_value: [],
                    field_value_name: "",
                    field_type: "eq",
                },
            ],
            // 复选框数据
            selectedList: [],
            userOptions: [],
            // 坏账
            badDebtDialogVisible: false,
            order_num: "",
            // 催款
            handleDialogTitle: "",
            handleDialogVisible: false,
            handleRemarks: "",
            handleDialogIds: [],
            // 详情
            unpaidDetailsDialogVisible: false,
            order_num: "",
        };
    },
    computed: {
        reduceHeight() {
            return this.pagination.total > 0 ? 215 : 170;
        },
        ...mapGetters(['hasPermission']),
        // 坏账操作权限：进行操作\查看权限；因为后台权限设置的是同一个按钮，所以判断一个权限的类型就行，如果之后权限分开了之后，就需要判断某一个按钮的权限了；目前我这里根据坏账列表的权限判断的
        hasBadDebtPermission() {
            return this.hasPermission('finance.receivable.badDebtList', 'finance', 'ReceivableManage');
        },
        // 操作权限：付款、确认、取消、驳回、作废等操作；因为后台权限设置的是同一个按钮，所以判断一个权限的类型就行，如果之后权限分开了之后，就需要判断某一个按钮的权限了；目前我这里根据批量驳回的权限判断的
        hasOperatePermission() {
            return this.hasPermission('finance.receivable.batchReject', 'finance', 'ReceivableManage');
        },
    },
    mixins: [pagination],
    created() {
        this.tabActiveName = "unpaid";
        this.searchFilterList = JSON.parse(JSON.stringify(this.unpaidSearchFilterList));
        this.getUserList();
        this.getTableData();
    },
    methods: {
        handleClickTab() {
            this.searchForm.keyword = "";
            if (this.tabActiveName == "unpaid") {
                this.searchFilterList = JSON.parse(JSON.stringify(this.unpaidSearchFilterList));
            } else {
                this.searchFilterList = JSON.parse(JSON.stringify(this.badDebtSearchFilterList));
            }
            this.tableData = [];
            this.handleClickSearch();
        },
        // 搜索
        handleClickSearch() {
            this.handleCurrentChange(1);
        },
        // 清空筛选条件
        handleClickReset() {
            this.searchFilterList.forEach((item) => {
                this.$set(item, "field_value", []);
            });
            this.handleClickSearch();
        },
        getUserList(keyword) {
            GetUserList({ keyword }).then((res) => {
                if (res.code === 200) {
                    this.userOptions = res.data || [];
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 表头配置
        handleClickCustom() {
            this.$refs.tableRef.handleOpenCustomShow();
        },
        // 表格复选框
        selectionChange(ids) {
            this.selectedList = ids;
        },
        // 页码改变
        handleCurrentChange(val) {
            this.pagination.pageNum = val;
            if (this.tabActiveName == "unpaid") {
                // 未回款
                this.getTableData();
            } else {
                // 坏账
                this.getBadDebtList();
            }
        },
        // 页数改变
        handleSizeChange(page) {
            this.pagination.pageNum = 1;
            this.pagination.pageSize = page.pageSize;
            if (this.tabActiveName == "unpaid") {
                // 未回款
                this.getTableData();
            } else {
                // 坏账
                this.getBadDebtList();
            }
        },
        // 未回款列表
        getTableData() {
            this.loading = true;
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.searchForm.keyword,
            };
            this.searchFilterList.forEach((item) => {
                if (item.field_value !== "") {
                    postData[item.field_key] = item.field_value;
                }
            });
            OrderUnpaidList(postData)
                .then((res) => {
                    if (res.code == 200) {
                        const { data, total } = res.data;
                        this.tableData = data || [];
                        this.pagination.total = total;
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },

        // 坏账列表
        getBadDebtList() {
            this.loading = true;
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.searchForm.keyword,
            };
            this.searchFilterList.forEach((item) => {
                if (item.field_value !== "") {
                    postData[item.field_key] = item.field_value;
                }
            });
            OrderBadDebtList(postData)
                .then((res) => {
                    if (res.code == 200) {
                        const { data, total } = res.data;
                        this.tableData = data || [];
                        this.pagination.total = total;
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 导出
        handleClickExport() {
            this.loading = true;
            if (this.tabActiveName == "unpaid") {
                let postData = {
                    page: 1,
                    pageSize: this.pagination.total,
                    keyword: this.searchForm.keyword,
                };
                this.searchFilterList.forEach((item) => {
                    if (item.field_value !== "") {
                        postData[item.field_key] = item.field_value;
                    }
                });
                OrderUnpaidListExport(postData)
                    .then((res) => {
                        if (res.code == 200) {
                            const { data, total } = res.data;
                            this.xlsxToExcel(data);
                        }
                        this.loading = false;
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            } else {
                let postData = {
                    page: 1,
                    pageSize: this.pagination.total,
                    keyword: this.searchForm.keyword,
                };
                this.searchFilterList.forEach((item) => {
                    if (item.field_value !== "") {
                        postData[item.field_key] = item.field_value;
                    }
                });
                OrderBadDebtListExport(postData)
                    .then((res) => {
                        if (res.code == 200) {
                            const { data, total } = res.data;
                            this.xlsxToExcel(data);
                        }
                        this.loading = false;
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            }
        },
        xlsxToExcel(exportData) {
            let tableData = [];
            let fields_list = [];
            const tabActiveName = this.tabActiveName;
            if (tabActiveName == "unpaid") {
                // 未回款
                fields_list = [{ field_key: "name", p_Field_key: "customer_info", field_name: "客户公司" }];
            } else {
                // 坏账
                fields_list = [{ field_key: "customer_name", field_name: "客户公司" }];
            }
            fields_list = fields_list.concat([
                { field_key: "order_num", field_name: "订单编号" },
                { field_key: "name", p_Field_key: "salesperson_info", field_name: "订单负责人" },
                { field_key: "department_leader", field_name: "部门负责人" },
                { field_key: "total_price", field_name: "订单总金额" },
                { field_key: "repay_price", field_name: "实际回款金额" },
                { field_key: "refund_price", field_name: "退款金额" },
            ]);
            if (tabActiveName == "unpaid") {
                fields_list.push({
                    field_key: "no_repay_price",
                    field_name: "未回款金额",
                });
            } else {
                fields_list = fields_list.concat([
                    { field_key: "bad_debt_amount", field_name: "坏账金额" },
                    { field_key: "mark_operate_time", field_name: "处理日期" },
                    { field_key: "name", p_Field_key: "mark_operate_info", field_name: "处理人" },
                ]);
            }

            tableData = exportData.map((row) => {
                const itemdata = {};
                fields_list.forEach((field) => {
                    if (field.field_key == "department_leader") {
                        // 部门负责人
                        if (tabActiveName == "unpaid") {
                            itemdata[field.field_name] = (row.department_leader || [])
                                .map((leaderItem) => leaderItem.name)
                                .join("、");
                        } else {
                            itemdata[field.field_name] = (row.department_leader_info || [])
                                .map((leaderItem) => leaderItem.name)
                                .join("、");
                        }
                    } else {
                        itemdata[field.field_name] = field.p_Field_key
                            ? row[field.p_Field_key]?.[field.field_key]
                            : row[field.field_key];
                    }
                });
                return itemdata;
            });

            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.json_to_sheet(tableData);
            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            const fileName = this.nowDate();
            XLSX.writeFile(wb, fileName);
        },
        nowDate() {
            const today = new Date();
            const year = today.getFullYear();
            const month = today.getMonth() + 1;
            const date = today.getDate() < 10 ? "0" + today.getDate() : today.getDate();
            const hours = today.getHours();
            const minutes = today.getMinutes();
            const seconds = today.getSeconds() < 10 ? "0" + today.getSeconds() : today.getSeconds();
            return `${
                this.tabActiveName == "unpaid" ? "未回款-" : "坏账款项-"
            }${year}年${month}月${date}日${hours}时${minutes}分${seconds}秒.xlsx`;
        },
        // 坏账
        handleClickBadDebt(row) {
            this.order_num = row.order_num;
            this.badDebtDialogVisible = true;
        },
        // 取消坏账
        handleClickCancelBadDebt(row) {
            const h = this.$createElement;
            this.$msgbox({
                title: "取消坏账",
                message: h("div", null, [
                    h("span", null, "是否要对该条取消坏账操作，取消后该条数据恢复到未回款中，是否继续？"),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: "prompt_message_custom",
                confirmButtonText: "确定",
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass: "",
                beforeClose: (action, instance, done) => {
                    if (action === "confirm") {
                        done();
                    } else {
                        done();
                    }
                },
            })
                .then(() => {
                    let postData = {
                        order_num: row.order_num,
                    };
                    this.loading = true;
                    OrderCancelBadDebt(postData).then((res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message);
                            this.getBadDebtList();
                        }
                        this.loading = false;
                    });
                })
                .catch(() => {});
        },
        // 批量催款
        handleClickBatchDemandPayment() {
            if (!this.selectedList.length) return this.$message.error("请至少选择一条");
            this.handleDialogVisible = true;
            this.handleDialogTitle = "催款";
            this.handleDialogIds = this.selectedList.map((item) => item.order_num);
        },
        // 单个催款
        handleClickDemandPayment(row) {
            this.handleDialogVisible = true;
            this.handleDialogTitle = "催款";
            this.handleDialogIds = [row.order_num];
        },
        // 弹框取消
        handleClickCancel() {
            this.handleDialogVisible = false;
            this.handleDialogTitle = "";
            this.handleRemarks = "";
            this.handleDialogIds = [];
        },
        // 弹框确认
        handleClickConfirm() {
            let error_msg = "请输入催款通知内容";
            if (!this.handleRemarks) return this.$message.error(error_msg);
            const params = {
                order_nums: this.handleDialogIds,
                content: this.handleRemarks,
            };
            OrderUrgePayment(params).then((res) => {
                if (res.code == 200) {
                    this.$message({
                        message: res.message,
                        type: "success",
                        duration: 1000,
                        onClose: () => {
                            this.handleClickSearch();
                            this.handleClickCancel();
                        },
                    });
                }
            });
        },
        // 查看详情
        handleClickDetail(row) {
            this.order_num = row.order_num;
            this.unpaidDetailsDialogVisible = true;
        },
        // 详情弹框操作
        handleDetailBtnOperate(params) {
            this.unpaidDetailsDialogVisible = false;
            if (params.type === "badDebt") {
                // 坏账
                this.handleClickBadDebt(params.row);
            } else {
                // 催款
                this.handleClickDemandPayment(params.row);
            }
        },
        // 查看客户详情
        handleClickCustomerDetail(customer_id, customer_name) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id,
                    name: customer_name,
                },
            });
        },
        // 订单详情
        handleClickOrderDetail(row) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: row.order_num,
                    name: row.order_num,
                    query_type: "order_no",
                },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.payable_component_wrap {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .el-tabs {
        ::v-deep {
            .el-tabs__nav {
                margin: 0 16px;
            }
            .el-tabs__header {
                margin: 0;
            }
            .el-tabs__item {
                padding: 0 16px !important;
                height: 48px;
                line-height: 48px;
                font-size: 16px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                &.is-active {
                    font-weight: 700;
                    color: rgba(41, 144, 255, 1);
                }
            }
        }
    }
    .content_right_wrap {
        flex: 1;
        padding: 16px;
    }
}
.dialog_label_text {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 22px;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 4px;
}
.search_container {
    width: 100%;
    padding: 4px;
    box-sizing: border-box;

    .search_top_container {
        display: flex;
        justify-content: space-between;

        span.title {
            line-height: 24px;
            color: rgba(51, 51, 51, 1);
            font-size: 16px;
            font-weight: bold;
        }

        .el-button {
            padding: 5px 10px;
        }
    }

    .search_bottom_container {
        padding: 16px 0 0px;
        box-sizing: border-box;

        ul {
            width: 100%;

            li {
                width: 100%;
                display: flex;
                margin-bottom: 12px;

                & > div:nth-child(1),
                & > div:nth-child(2) {
                    flex: 1;
                }
                & > div:nth-child(3) {
                    width: 225px;
                    flex-shrink: 0;
                    .el-select {
                        width: 100%;
                    }
                }

                .search_filter_type {
                    margin: 0 8px;
                    width: 86px;
                    max-width: 86px;
                }

                .el-date-editor.el-input {
                    width: 100%;
                    display: block;
                }
                .el-date-editor {
                    width: 100% !important;
                    ::v-deep {
                        .el-range-separator {
                            width: 10%;
                            padding: 0;
                        }
                    }
                }
            }
        }
    }
}
.custom_popover_button {
    padding: 8px 8px;
    margin-left: 0px;
    i {
        font-size: 14px;
    }
    .search_filter_length {
        margin-left: 8px;
        i {
            margin-left: 8px;
            color: rgba(173, 173, 173, 1);
        }
    }
}
</style>
<style lang="scss">
.repayment_log_popover {
    padding: 16px 16px 0;
    max-height: 314px;
    overflow-y: auto;
    .repayment_log_popover_content {
        ul {
            width: 100%;
            li {
                width: 100%;
                padding-left: 24px;
                padding-bottom: 12px;
                box-sizing: border-box;
                position: relative;
                &:before {
                    width: 16px;
                    height: 16px;
                    border-radius: 50%;
                    content: " ";
                    left: 0;
                    top: 3px;
                    position: absolute;
                    border: 4px solid rgba(90, 179, 51, 1);
                    background: #fff;
                    z-index: 9;
                }
                &:after {
                    width: 1px;
                    height: 100%;
                    position: absolute;
                    left: 7px;
                    top: 3px;
                    border: 1px dashed rgba(232, 232, 232, 1);
                    content: " ";
                }
                &:last-child:after {
                    display: none;
                }
                p:nth-child(1) {
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(153, 153, 153, 1);
                    margin-bottom: 4px;
                }
                p:nth-child(2) {
                    font-size: 14px;
                    font-weight: 500;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(102, 102, 102, 1);
                }
            }
        }
    }
}
</style>
